import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Project, ProjectStatsConfiguration } from '../../../interfaces/project';
import { Publication } from '../../../interfaces/publication';
import { PublicationService } from '../../../services/publication.service';
import { OverlayService, ModalDefinition } from '../../../services/overlay.service';
import { FlowchartStep } from './../../../shared/models/flowchart-step.model';
import { Subscription } from 'rxjs';
import { ProjectService } from './../../../services/project.service';

@Component({
	selector: 'flowchart-stats-step',
	templateUrl: './flowchart-stats-step.component.html',
	styleUrls: ['./flowchart-stats-step.component.scss']
})
export class FlowchartStatsStepComponent implements OnInit, OnDestroy {
	@Input() selected = false;
	@Input() project: Project;
	@Input() step: FlowchartStep;

	configuration: ProjectStatsConfiguration;
	minimized = false;
	thumbSrc: string;

	thumbMouseDownX: number;
	thumbMouseDownY: number;

	projectStats: Project;
	subscriptions = new Subscription();

	stepStats: any;

	constructor(
		private publicationService: PublicationService,
		private overlayService: OverlayService,
		protected projectService: ProjectService
	) {
	}

	ngOnInit() {
		this.subscriptions.add(this.projectService.projectWithStatsSubject.subscribe((projectStats: Project) => {
			this.projectStats = projectStats;
			this.parseProjectStats();
		}));

		this.subscriptions.add(this.publicationService.getData().subscribe((publication: Publication) => {
			if (publication && this.step && this.step.entityId) {
				this.thumbSrc = publication.baseurl + '/mediaclip/' + this.step.entityId + '/spthumbnail/640/480.jpg';
			}
		}));
	}


	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	parseProjectStats() {
		if (this.projectStats?.chapters && this.step?.entityId) {
			const chapterLength = this.projectStats.chapters.length;
			for (let i = 0; i < chapterLength; i++) {
				this.projectStats.chapters[i].steps.forEach((step) => {
					if (step.entityId === this.step.entityId) {
						this.stepStats = step;
					}
				});
			}
		}
	}

	showClipDetails(id: string, title: string) {
		this.configuration = this.projectService.getStatsConfiguration();
		if (!this.project) {
			this.project = this.projectService.getProject();
		}
		const statsStep = this.projectService.findStep(id, this.project);
		const modal: ModalDefinition = {
			icon: 'film',
			title,
			component: {
				name: 'stats-progress',
				inputs: {
					clipId: statsStep.entityId,
					parentEntityId: this.project.id,
					parentEntityType: 'Project',
					configuration: this.configuration
				}
			}
		};

		this.overlayService.createModal(modal);
	}

	public loadPlaceholder(event: any): void {
		if (event?.target?.parentElement) {
		  event.target.parentElement.classList.add('no-thumb');
		}
	  }
}
